import { FunnelConfigResponseDTO } from "@requests"
import {ref, Ref} from "vue"

const funnelConfig: Ref<FunnelConfigResponseDTO | null> = ref(null)

export default funnelConfig